import { Link, useLocation } from '@tanstack/react-router'
import { GiftIcon } from 'lucide-react'

import { cn } from '@/utils'
import { useHasUnreadUpdates, useTrackLatestUpdate } from '../hooks'

export const UpdatesNavItem = () => {
  const location = useLocation()
  useTrackLatestUpdate()
  const hasUnread = useHasUnreadUpdates()
  const active = location.pathname.startsWith('/updates')

  return (
    <Link
      to="/updates"
      preload="intent"
      data-active={active}
      aria-label={hasUnread ? 'Updates, new updates available' : 'Updates'}
      className={cn(
        'group flex w-full items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-blue-7 outline-none transition-colors cursor-pointer',
        'focus-visible:ring-2 focus-visible:ring-brand/20',
        active
          ? 'bg-brand/10 font-semibold'
          : 'hover:bg-muted/50 hover:text-foreground',
      )}
    >
      <GiftIcon
        className={cn(
          'h-4 w-4 shrink-0 transition-colors',
          active ? 'text-brand' : 'text-blue-6 group-hover:text-foreground',
        )}
      />
      <span className="truncate text-pretty">Updates</span>
      {hasUnread && (
        <span className="relative ml-auto flex h-2 w-2 shrink-0">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand/60 motion-reduce:hidden" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-brand" />
        </span>
      )}
    </Link>
  )
}
